var SV = require('server-vars');
var cookies = require('browser-cookies');

function getAdminUserData() {
    return SV.get('userData');
};

function getSellerData() {
    return SV.get('sellerData');
};

/**
 * Returns either a sellerToken or userToken depending on who is currently logged in.
 * @returns {String} The token for the currently logged in user.
 */
module.exports = function getToken() {
    var token;
    var tokenObj = {};
    var userData = getAdminUserData();
    var sellerData = getSellerData();
    var cookieToken = cookies.get('userToken');

    if (typeof window === 'undefined') {
        return {};
    }

    //Set user token for masquerade
    if (sellerData && userData) {
        token = cookieToken ? cookieToken : userData.token;
        tokenObj.userToken = token;
    //Be extra sure we only send the sellerToken when we're on an Admin page
    } else if (sellerData) {
        token = sellerData.token;
        tokenObj.sellerToken = token;
    } else if (cookieToken) {
        token = cookieToken;
        tokenObj.userToken = token;
    }
    return token ? tokenObj : null;
};



//////////////////
// WEBPACK FOOTER
// ./~/dibs-get-token/index.js
// module id = 510
// module chunks = 4 6 8 9 11 16 17 22 26 29 58